import { plainText } from "@/lib/htmlContentHelpers";

const DEFAULT_MAX_LENGTH = 100;

export function clipTaskDescription(
  description: string | null | undefined,
  maxLength = DEFAULT_MAX_LENGTH
): string | undefined {
  const trimmed = description?.trim();
  if (!trimmed) return undefined;

  const text = plainText(trimmed);
  if (!text) return undefined;
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3).trimEnd()}...`;
}

export function taskPreviewSubtitle(name: string, description: string | null | undefined): string | undefined {
  const clipped = clipTaskDescription(description);
  if (!clipped || clipped === name.trim()) return undefined;
  return clipped;
}
